import {
  getDefaultPersonalTemplateCode,
  getPersonalSectionMaxCount,
  resolvePersonalTemplateCode,
} from '../personalLanding/registry'

export const CARD_TEMPLATE_OPTIONS = [
  {
    id: 'CARD_V1',
    label: '기본형',
    description: '기본 명함 레이아웃',
  },
  {
    id: 'CARD_V2',
    label: '프리미엄형',
    description: '큰 프로필 블록·방사형 하이라이트가 있는 클래식 프리미엄(딥네이비 + 스카이 포인트)',
  },
  {
    id: 'CARD_V3',
    label: '클린형',
    description: '밝고 깔끔한 상담형 레이아웃',
  },
  {
    id: 'CARD_V4',
    label: '센터 블루',
    description: '한가운데 정렬·딥블루 배경의 심플 전자명함 스타일',
  },
  {
    id: 'CARD_V5',
    label: '브랜드 블록',
    description: '상단 화이트 + 네이비 히어로 + 하단 비주얼(프로필 사진) 강조',
  },
  {
    id: 'CARD_V6',
    label: '모노 다크',
    description: '블랙 배경·고대비 타이포의 미니멀 프리미엄',
  },
  {
    id: 'CARD_V7',
    label: '포레스트',
    description: '딥그린·크림 톤의 차분한 내추럴 스타일',
  },
  {
    id: 'CARD_V8',
    label: '매거진',
    description: '상단 히어로 이미지 + 겹침 카드형 레이아웃',
  },
  {
    id: 'CARD_V9',
    label: '타임라인 네이비',
    description: '상단 명함 정보 + 슬로건 + 네이비 하단(서비스·연혁·강조 수치) 레이아웃',
  },
  {
    id: 'CARD_V10',
    label: '허브 라이트',
    description: '상단 비주얼·프로필·경력/자유소개·태그를 한 흐름으로 묶은 밝은 허브형',
  },
  {
    id: 'CARD_V11',
    label: '허브 다크',
    description: '허브형 정보 밀도 + 에메랄드 포인트의 슬레이트 다크(프리미엄형과 톤·구성이 다름)',
  },
  {
    id: 'CARD_V12',
    label: '프로필사진강조',
    description: '대형 프로필(화면 대부분) + 하단 겹침 반투명 정보 카드 + 흰색 연락처 목록',
  },
]

export const LANDING_SECTION_OPTIONS = [
  { type: 'hero', label: '상단 소개', required: true },
  { type: 'about-profile', label: '프로필 소개' },
  { type: 'service-tags', label: '서비스 태그' },
  { type: 'proof-stats', label: '성과 지표' },
  { type: 'monthly-issue', label: '이달의 이슈' },
  { type: 'media-gallery', label: '미디어 갤러리' },
  { type: 'image-card', label: '이미지 카드' },
  { type: 'career', label: '경력' },
  { type: 'customer-case', label: '상담 사례' },
  { type: 'activity', label: '활동지역' },
  { type: 'free-text', label: '자유 소개' },
  { type: 'contact', label: '문의 정보' },
  { type: 'cta', label: '상담 유도' },
  { type: 'credentials', label: '자격·이력' },
  { type: 'values', label: '고객 약속' },
  { type: 'faq', label: '자주 묻는 질문' },
  { type: 'ad-review', label: '광고 심의필·준법', required: true },
]

export const LANDING_LAYOUT_PRESETS = [
  { id: 'trust', label: '신뢰형', description: '경력·지표·약속으로 신뢰를 쌓는 구성' },
  { id: 'conversion', label: '전환형', description: '이슈·사례·CTA로 상담 신청을 이끄는 구성' },
  { id: 'brand', label: '브랜드형', description: '스토리·갤러리로 톤앤매너를 드러내는 구성' },
]

/** 공개 소개페이지 시각 스킨(저장: user_public_pages.landing_template_id) */
export const LANDING_SKIN_OPTIONS = [
  { id: 'LANDING_V1', label: '기본' },
  { id: 'LANDING_V2', label: '클린' },
]

const LANDING_SECTION_META = Object.fromEntries(
  LANDING_SECTION_OPTIONS.map((item) => [item.type, item])
)

/**
 * 빈 저장·초기 구성·섹션 추가 시 기본값: 상단 메뉴(및 해당 블록)에 올릴지 여부.
 * ON: 상단 소개, 경력, 활동지역, 문의, 상담 유도(CTA), 자격·이력, FAQ — 그 외 타입은 기본 OFF.
 */
export function isLandingSectionDefaultMenuOn(type) {
  const t = typeof type === 'string' ? type.trim() : ''
  return (
    t === 'hero'
    || t === 'career'
    || t === 'activity'
    || t === 'contact'
    || t === 'cta'
    || t === 'credentials'
    || t === 'faq'
  )
}

function defaultSectionContent(type) {
  switch (type) {
    case 'service-tags':
      return {
        title: '이런 도움을 드립니다',
        items: [],
      }
    case 'about-profile':
      return {
        title: '왜 저와 상담하시면 좋을까요',
        body:
          '가입만 하고 끝이 아니라, 해지·갱신·청구까지 생활이 바뀔 때마다 같이 점검하는 것을 지향합니다.\n'
          + '같은 보험료로도 필요한 보장에 맞게 정리할 수 있는지, 먼저 솔직하게 짚어 드립니다.\n'
          + '(위 문장은 예시입니다. 본인 스타일에 맞게 고치시면 됩니다.)',
      }
    case 'proof-stats':
      return {
        title: '함께해 온 시간',
        items: [
          { label: '누적 1:1 상담', value: '850+' },
          { label: '보장 점검 진행', value: '320+' },
          { label: '월 평균 신규 상담', value: '약 25건' },
        ],
      }
    case 'customer-case':
      return {
        title: '상담 후 이렇게 바뀌었어요',
        items: [
          {
            title: '실손·암 중복 정리',
            body:
              '실손이 여러 건 겹쳐 있던 고객님께 유지할 계약과 정리할 계약을 나누어, 월 납입은 줄이고 핵심 보장은 유지하는 방향으로 정리했습니다.',
          },
          {
            title: '은퇴 준비와 보장 구조',
            body:
              '노후 자금 흐름을 먼저 잡은 뒤, 생활비·의료비 공백이 없는지 순서대로 점검해 단계별로 맞춰 드렸습니다.',
          },
        ],
      }
    case 'media-gallery':
      return {
        title: '상담 현장·자료 스케치',
        body: '아래 이미지는 예시 영역입니다. 본인 사진·인증·세미나·고객 후기 캡처 등을 올리면 방문자에게 더 구체적으로 전달됩니다.',
      }
    case 'cta':
      return {
        title: '부담 없이 한 번만 이야기 나눠보세요',
        body:
          '이름과 연락처만 남겨 주셔도 됩니다. 희망하시면 통화 가능한 시간대를 적어 주시면 그때 맞춰 연락드리겠습니다.',
      }
    case 'credentials':
      return {
        title: '자격·교육 이력',
        items: [
          { title: '생명·손해보험 설계사', subtitle: '금융위 등록(해당 시)', year: '' },
          { title: '상품·윤리 연수', subtitle: '협회·소속사 정기 이수', year: '' },
          { title: '보험연수원·세미나', subtitle: '상속·노후·실손 등', year: '' },
        ],
      }
    case 'values':
      return {
        title: '상담할 때 지키는 원칙',
        items: [
          {
            title: '필요한 것만 말씀드립니다',
            body: '당장 팔기 위한 상품 나열 대신, 지금 가족 상황에서 비어 있는 보장부터 짚습니다.',
          },
          {
            title: '숫자로 확인합니다',
            body: '가입 전 보장금액·면책·감액 기간 등 약관 핵심을 같이 보며 정리합니다.',
          },
          {
            title: '이후에도 문의 환영',
            body: '가입 후에도 청구·갱신·해지 전에 한 번만 물어보셔도 됩니다.',
          },
        ],
      }
    case 'faq':
      return {
        title: '자주 묻는 질문',
        items: [
          {
            q: '첫 상담은 비용이 드나요?',
            a: '보통 첫 1회는 상황 파악과 방향 제안 위주로 무료로 진행합니다. 이후 설계·정리가 구체화되면 그때 단계별로 안내드립니다.',
          },
          {
            q: '이미 가입한 보험이 많은데도 상담이 필요할까요?',
            a: '네. 오히려 계약이 많을수록 중복·공백이 생기기 쉽습니다. 갖고 계신 증권을 기준으로 정리만 도와드릴 수도 있습니다.',
          },
          {
            q: '비대면만 가능한가요?',
            a: '전화·문자·카카오 등 가능한 채널로 조율합니다. 필요하시면 서류 확인용으로 화상·방문도 논의 가능합니다.',
          },
        ],
      }
    case 'monthly-issue':
      return {
        /** 카드뉴스만 노출 — 제목·설명 필드는 사용하지 않음(레거시 데이터는 무시) */
        title: '',
        body: '',
        /** monthly_brief | template — 개인홈 편집기에서 선택 */
        cardNewsSource: 'monthly_brief',
        cardNewsTemplateId: null,
        /** template 소스: 운영 템플릿 preset에 포함된 스냅샷 { periodLabel?, payload?, images:[{fileId,imageName}] } */
        cardNewsTemplateEmbed: null,
      }
    case 'ad-review':
      return {
        title: '광고 심의필 · 준법 표기',
        body:
          '「소속사(또는 모집 주체)명」 준법감시인 심의필 제○호 (유효기간: 20××.××.×× ~ 20××.××.××)\n'
          + '※ 위는 예시입니다. 실제로는 소속 GA·보험사·대리점 등에서 받은 심의필 문구·기간·표기 위치를 그대로 옮겨 적어 주세요. 광고 매체별로 심의가 나뉘어 있으면 해당 매체용 문구를 쓰시면 됩니다. 미수정 시 예시가 그대로 노출되므로 반드시 교체해 주세요.',
      }
    default:
      return {}
  }
}

function createSection(type, order, enabled = true, content = undefined) {
  return {
    id: `${type}-${order + 1}`,
    type,
    enabled,
    order,
    content: content ?? defaultSectionContent(type),
    templateCode: getDefaultPersonalTemplateCode(type) || undefined,
    assets: {},
  }
}

export function getCardTemplateMeta(templateId) {
  const raw = templateId == null ? '' : String(templateId).trim()
  const exact = CARD_TEMPLATE_OPTIONS.find((item) => item.id === raw)
  if (exact) return exact
  const upper = raw.toUpperCase()
  return CARD_TEMPLATE_OPTIONS.find((item) => item.id === upper) || CARD_TEMPLATE_OPTIONS[0]
}

/** 명함 템플릿별 프로필 사진 권장 해상도·비율(`PublicCard.js` 썸네일·히어로 영역 기준) */
const PROFILE_IMAGE_SIZE_GUIDE = {
  CARD_V1:
    '원형 영역(표시 약 112×112px). 600×600px 이상 정사각형, 얼굴·상반신이 중앙에 오게.',
  CARD_V2:
    '둥근 사각(약 128×128px). 720×720px 이상 정사각형 권장.',
  CARD_V3:
    '라운드 사각(약 112×112px). 600×600px 이상 정사각형 권장(비율이 다르면 가장자리가 잘릴 수 있음).',
  CARD_V4:
    '원형(약 96×96px). 512×512px 이상 정사각형.',
  CARD_V5:
    '카드 하단 가로 전체·세로 고정 배너. 가로 3:2 ~ 16:9(예: 1200×800, 1920×1080) 가로형, 중요 피사체는 중앙~중하단.',
  CARD_V6:
    '정사각(약 144×144px). 600×600px 이상 정사각형.',
  CARD_V7:
    '작은 원형(약 80×80px). 400×400px 이상 1:1이면 충분.',
  CARD_V8:
    '상단 풀폭 히어로(높이 고정). 16:9 또는 3:2 가로형(예: 1600×900, 1200×800). 잘림은 위·아래에 생길 수 있어 피사체는 중앙~상단.',
  CARD_V9:
    '카드 하단 넓은 띠에 비율 유지로 표시. 가로 1200px 이상, 4:3 또는 3:2 가로형이 무난(세로 긴 사진은 작게 맞춰짐).',
  CARD_V10:
    '작은 사각 썸네일(약 84×84px). 512×512px 이상 정사각형, 얼굴이 잘 보이게.',
  CARD_V11:
    '작은 사각 썸네일(약 84×84px). 512×512px 이상 정사각형, 얼굴이 잘 보이게.',
  CARD_V12:
    '세로 풀 히어로에 비율 유지로 채움. 4:5 또는 3:4 세로형(960px 이상) 권장. 얼굴·상반신이 중앙에 오게.',
}

/**
 * 웹 `PublicCard.js` 렌더 기준 모바일 명함 편집 화면 노출.
 * - DB 필드는 유지하되, 웹 명함에 쓰이지 않는 입력은 숨긴다.
 * - 템플릿마다 레이아웃만 다르고 공통 필드가 대부분이므로, 차이는 주로 안내 문구로 표현한다.
 */
export function getCardTemplateEditUiConfig(templateId) {
  const id = getCardTemplateMeta(templateId).id
  /** PublicCard.js — cardOrgLogoUrl 실제 노출 템플릿만 편집 UI 제공 */
  const showOrgLogoEditor = id === 'CARD_V2' || id === 'CARD_V10' || id === 'CARD_V11' || id === 'CARD_V12'
  /** 이미지 카드(히어로) — 허브형만 렌더에서 사용 */
  const showImageCardEditor = id === 'CARD_V10' || id === 'CARD_V11'
  /** PublicCard — introText/bioShort 합쳐 `intro`로 쓰이는 템플릿(V12는 화면에 intro 미노출) */
  const showCardIntroEditor = id !== 'CARD_V12'
  /** 경력·자유 소개 카드 — CardTemplateHub(V10/V11)만 */
  const showCareerFreeEditors = id === 'CARD_V10' || id === 'CARD_V11'
  return {
    showOrgLogoEditor,
    showImageCardEditor,
    showCardIntroEditor,
    showCareerFreeEditors,
    profileImageSizeGuide: PROFILE_IMAGE_SIZE_GUIDE[id] || PROFILE_IMAGE_SIZE_GUIDE.CARD_V1,
    profileExtraHint:
      id === 'CARD_V5'
        ? '이 템플릿은 프로필 사진이 카드 하단 큰 영역으로 강조됩니다.'
        : id === 'CARD_V8'
          ? '이 템플릿은 프로필 사진이 상단 히어로를 채웁니다.'
          : id === 'CARD_V10' || id === 'CARD_V11'
            ? '허브형: 「이미지 카드」를 켜면 상단 히어로로 쓰입니다. 경력·자유 소개 카드도 명함에 함께 나갑니다.'
            : id === 'CARD_V12'
              ? '프로필사진강조: 프로필 사진이 카드 상단 대부분을 채웁니다. 조직 로고는 정보 카드 우측에 표시됩니다.'
              : null,
    showTimelineYearEditor: id === 'CARD_V9',
    introBlockBanner:
      id === 'CARD_V9'
        ? '타임라인 네이비: 인용 슬로건은 「간단 소개글 → 없으면 한 줄 소개」의 첫 줄이 들어갑니다. 하단 강조 문구는 소개·활동 텍스트에서 숫자+건/명/회 패턴을 찾아 씁니다. 타임라인은 아래에서 연도와 짧은 설명(선택)을 입력합니다(연도 2개 미만이면 올해 기준 자동 간격).'
        : null,
    serviceTagsLabelExtra:
      id === 'CARD_V9' ? ' (네이비 영역 아이콘 최대 5개, 부족하면 기본 문구로 채움)' : '',
    activityLabelExtra:
      id === 'CARD_V9' ? ' (첫 줄이 상단 우측 보조 문구로 쓰일 수 있음)' : '',
  }
}

export function getLandingSectionMeta(type) {
  return LANDING_SECTION_META[type] || null
}

export function createDefaultLandingSections(_data = {}) {
  const on = isLandingSectionDefaultMenuOn
  return [
    createSection('hero', 0, on('hero')),
    createSection('about-profile', 1, on('about-profile')),
    createSection('service-tags', 2, on('service-tags')),
    createSection('proof-stats', 3, on('proof-stats')),
    createSection('monthly-issue', 4, on('monthly-issue')),
    createSection('media-gallery', 5, on('media-gallery')),
    createSection('image-card', 6, on('image-card')),
    createSection('career', 7, on('career')),
    createSection('customer-case', 8, on('customer-case')),
    createSection('activity', 9, on('activity')),
    createSection('free-text', 10, on('free-text')),
    createSection('contact', 11, on('contact')),
    createSection('cta', 12, on('cta')),
    createSection('credentials', 13, on('credentials')),
    createSection('faq', 14, on('faq')),
    createSection('ad-review', 15, true),
  ]
}

export function normalizeLandingSections(rawSections, data = {}) {
  const fallback = createDefaultLandingSections(data)
  if (!Array.isArray(rawSections) || rawSections.length === 0) {
    return fallback
  }

  const countByType = {}
  const items = []
  rawSections.forEach((item, index) => {
    const type = typeof item?.type === 'string' ? item.type.trim() : ''
    if (!type || !LANDING_SECTION_META[type]) return
    const max = getPersonalSectionMaxCount(type)
    const used = countByType[type] || 0
    if (used >= max) return
    countByType[type] = used + 1
    items.push({
      id: typeof item?.id === 'string' && item.id.trim() ? item.id.trim() : `${type}-${index + 1}`,
      type,
      enabled: item?.enabled !== false,
      order: typeof item?.order === 'number' ? item.order : items.length,
      content: item?.content && typeof item.content === 'object' ? item.content : defaultSectionContent(type),
      templateCode:
        resolvePersonalTemplateCode(type, item?.templateCode) ||
        getDefaultPersonalTemplateCode(type) ||
        undefined,
      assets: item?.assets && typeof item.assets === 'object' ? item.assets : {},
    })
  })

  const ordered = items
    .sort((a, b) => a.order - b.order)
    .map((item, index) => ({ ...item, order: index }))

  if (!ordered.some((item) => item.type === 'hero')) {
    ordered.unshift(createSection('hero', 0, true))
  }

  if (!ordered.some((item) => item.type === 'ad-review')) {
    ordered.push(createSection('ad-review', ordered.length, true))
  }

  return ordered.map((item, index) => {
    const next = {
      ...item,
      order: index,
      id: item.id || `${item.type}-${index + 1}`,
    }
    if (next.type === 'ad-review') next.enabled = true
    return next
  })
}

export function serializeLandingSections(sections) {
  return normalizeLandingSections(sections).map((item, index) => ({
    id: item.id || `${item.type}-${index + 1}`,
    type: item.type,
    enabled: item.enabled !== false,
    order: index,
    content: item?.content && typeof item.content === 'object' ? item.content : {},
    templateCode:
      resolvePersonalTemplateCode(item.type, item.templateCode) ||
      getDefaultPersonalTemplateCode(item.type) ||
      undefined,
    assets: item.assets && typeof item.assets === 'object' ? item.assets : {},
  }))
}

export function createLandingSectionDraft(type, currentSections = []) {
  const meta = getLandingSectionMeta(type)
  if (!meta) return null
  const max = getPersonalSectionMaxCount(type)
  const n = (currentSections || []).filter((item) => item?.type === type).length
  if (n >= max) return null
  const enabledDefault = type === 'ad-review' ? true : isLandingSectionDefaultMenuOn(type)
  const draft = createSection(type, currentSections.length, enabledDefault)
  return { ...draft, id: `${type}-${n + 1}-${Math.random().toString(36).slice(2, 8)}` }
}

export function moveSection(sections, fromIndex, toIndex) {
  const list = Array.isArray(sections) ? [...sections] : []
  if (fromIndex < 0 || toIndex < 0 || fromIndex >= list.length || toIndex >= list.length) return list
  const [picked] = list.splice(fromIndex, 1)
  list.splice(toIndex, 0, picked)
  return list.map((item, index) => ({ ...item, order: index }))
}

/**
 * 서비스 태그 문자열 → 배열(최대 12).
 * - `#태그1#태그2` 형태(해시 구분) 우선
 * - 해시가 없으면 기존 `쉼표` 구분 호환
 */
export function splitTags(raw) {
  if (raw == null) return []
  const s = String(raw).trim()
  if (!s) return []
  if (s.includes('#')) {
    return s
      .split('#')
      .map((t) => t.trim())
      .filter(Boolean)
      .slice(0, 12)
  }
  return s
    .split(',')
    .map((t) => t.trim())
    .filter(Boolean)
    .slice(0, 12)
}

export function createLandingSectionsFromPreset(data = {}, presetId = 'trust') {
  const introFromProfile = typeof data?.introText === 'string' && data.introText.trim() ? data.introText.trim() : ''

  const aboutBodyTrust =
    introFromProfile
    || [
      '“가입하고 끝”이 아니라, 해지·갱신·청구까지 생활이 바뀔 때마다 같이 보는 설계를 지향합니다.',
      '같은 보험료라도 필요한 보장에 맞게 쓰이고 있는지, 불필요한 중복은 없는지 먼저 솔직하게 짚어 드립니다.',
      '지금 갖고 계신 증권만 가지고 오셔도 방향 제안은 가능합니다. 부담 없이 연락 주세요.',
    ].join('\n')

  const aboutBodyConversion =
    introFromProfile
    || [
      '보험이 많은지·부족한지 스스로 판단하기 어렵다면, 20~30분 통화로 현재 상태만이라도 정리해 드립니다.',
      '희망 연락 시간을 남겨 주시면 그 시간에 맞춰 드리고, 급하지 않으시면 문자로 먼저 일정 조율도 가능합니다.',
    ].join('\n')

  const aboutBodyBrand =
    introFromProfile
    || [
      '가족 구성·소득·부채·노후 목표가 모두 다르다고 믿습니다.',
      '정해진 패키지보다, 지금 삶의 우선순위에 맞춰 단계적으로 제안드리는 편입니다.',
      '아래 갤러리와 글은 예시 톤입니다. 본인 색에 맞게 고치시면 됩니다.',
    ].join('\n')

  const heroTrust = { eyebrow: '맞춤 보장 · 1:1 설계', ctaText: '보장 점검 상담 신청' }
  const heroConversion = { eyebrow: '오늘도 상담 가능', ctaText: '무료 상담 요청하기' }
  const heroBrand = { eyebrow: '설계 EZ 파트너', ctaText: '첫 상담 남기기' }

  const statsTrust = {
    title: '함께해 온 발자취',
    items: [
      { label: '누적 1:1 상담', value: '850+' },
      { label: '보장 점검 진행', value: '320+' },
      { label: '월 평균 신규 상담', value: '약 25건' },
    ],
  }
  const statsConversion = {
    title: '상담 응대 기준',
    items: [
      { label: '평일 문의 응답', value: '당일 내' },
      { label: '첫 통화 가능', value: '1~2영업일' },
      { label: '누적 상담 건수', value: '850+' },
    ],
  }

  const caseConversion = {
    title: '실제 상담에서 자주 나온 변화',
    items: [
      {
        title: '실손·진단비 중복 줄이기',
        body:
          '여러 계약에 실손·암·뇌혈관이 겹쳐 있던 경우, 유지할 계약과 정리할 계약을 나누어 월 부담은 낮추고 사고·질병 시 핵심은 유지하도록 정리했습니다.',
      },
      {
        title: '은퇴 10년 전 점검',
        body:
          '노후 생활비 시나리오를 먼저 잡은 뒤, 의료비·간병 공백이 없는지 순서대로 점검해 단계별로 맞췄습니다.',
      },
    ],
  }

  const galleryBrand = {
    title: '현장·세미나·자료 스케치',
    body:
      '상담 공간, 협회·보험사 세미나, 고객 후기(동의하신 분만) 등 이미지를 올리면 첫인상이 훨씬 구체적으로 전달됩니다. 아래는 안내용 예시 문구입니다.',
  }

  const freeBrand = {
    title: '제가 상담할 때 가장 중요하게 보는 것',
    body:
      '① 지금 가족에게 일어날 수 있는 리스크 순서 ② 이미 가입한 계약으로 커버되는지 ③ 남는 공백을 같은 예산으로 어떻게 메울지.\n'
      + '순서를 지키면 불필요한 신규 가입 없이도 정리가 되는 경우가 많습니다. (본인 문장으로 바꿔 쓰시면 됩니다.)',
  }

  const ctaTrust = {
    title: '증권만 있어도 괜찮습니다',
    body: '이름·연락처와 통화 가능한 시간대만 남겨 주세요. 가입을 권유하기보다, 지금 상태 파악부터 도와드리겠습니다.',
  }
  const ctaConversion = {
    title: '지금 남기시면 순서대로 연락드립니다',
    body: '간단히 남겨 주시면 중복 전화 없이 1~2영업일 안에 한 번 연락드립니다. 급하시면 전화번호로 직접 주셔도 됩니다.',
  }
  const ctaBrand = {
    title: '톤이 맞는지 먼저 나눠보세요',
    body: '상담 스타일이 맞지 않으면 부담 없이 그만두셔도 됩니다. 편한 방법(전화·문자·카카오)을 알려 주세요.',
  }

  const monthlyConversion = {
    title: '',
    body: '',
  }

  const on = isLandingSectionDefaultMenuOn
  const byType = {
    hero: createSection(
      'hero',
      0,
      on('hero'),
      presetId === 'conversion' ? heroConversion : presetId === 'brand' ? heroBrand : heroTrust
    ),
    about: createSection('about-profile', 1, on('about-profile'), {
      title: presetId === 'brand' ? '제가 상담을 하는 방식' : presetId === 'conversion' ? '빠르게 정리부터 도와드립니다' : '왜 저와 상담하시면 좋을까요',
      body: presetId === 'conversion' ? aboutBodyConversion : presetId === 'brand' ? aboutBodyBrand : aboutBodyTrust,
    }),
    tags: createSection('service-tags', 2, on('service-tags'), {
      title: presetId === 'conversion' ? '이런 분께 먼저 추천드립니다' : presetId === 'brand' ? '도움 드리는 영역' : '이런 도움을 드립니다',
    }),
    stats: createSection('proof-stats', 3, on('proof-stats'), presetId === 'conversion' ? statsConversion : statsTrust),
    monthlyIssue: createSection('monthly-issue', 4, on('monthly-issue'), monthlyConversion),
    gallery: createSection('media-gallery', 5, on('media-gallery'), galleryBrand),
    imageCard: createSection('image-card', 6, on('image-card')),
    career: createSection('career', 7, on('career')),
    case: createSection('customer-case', 8, on('customer-case'), caseConversion),
    activity: createSection('activity', 9, on('activity')),
    free: createSection('free-text', 10, on('free-text'), freeBrand),
    contact: createSection('contact', 11, on('contact')),
    credentials: createSection('credentials', 12, on('credentials')),
    faq: createSection('faq', 13, on('faq')),
    cta: createSection(
      'cta',
      14,
      on('cta'),
      presetId === 'conversion' ? ctaConversion : presetId === 'brand' ? ctaBrand : ctaTrust
    ),
    adReview: createSection('ad-review', 15, true),
  }

  const orderMap = {
    trust: ['hero', 'about', 'tags', 'stats', 'career', 'activity', 'contact', 'cta', 'credentials', 'faq', 'adReview'],
    conversion: ['hero', 'about', 'monthlyIssue', 'case', 'stats', 'imageCard', 'contact', 'cta', 'credentials', 'faq', 'adReview'],
    brand: ['hero', 'about', 'gallery', 'free', 'tags', 'contact', 'cta', 'credentials', 'faq', 'adReview'],
  }
  const order = orderMap[presetId] || orderMap.trust
  return order.map((key, index) => ({ ...byType[key], order: index, id: `${byType[key].type}-${index + 1}` }))
}
